import { AppThunkAction } from './appThunkAction';
import api from '../../helpers/api';
import { isRequestPending } from '../selectors/requestStatusSelectors';
import { RequestStatusType } from '../state/requestStatusState';
import { trackStatusForRequest } from './requestStatusActions';
import { EngagementExpandedSummary } from '../../models/dto/engagement';

export function loadEngagementIfMissing(id: number): AppThunkAction {
	return (dispatch, getState) => {
		const state = getState();
		const engagements = state.engagements;
		
		if (engagements.details.has(id) || isRequestPending(state, RequestStatusType.LoadEngagement, id))
			return;
		
		const request = api.get<EngagementExpandedSummary>(`/api/engagements/${id}`).then(response => {
			dispatch({ type: 'engagements/details-loaded', engagement: response.data, id });
		});

		dispatch(trackStatusForRequest(request, RequestStatusType.LoadEngagement, id));
	}
}

export interface EngagementDetailsLoaded {
    type: 'engagements/details-loaded';
    engagement: EngagementExpandedSummary;
    id: number;
}

export type EngagementsActions = EngagementDetailsLoaded;